/**
 * drawing_2d.processing_status の分類。
 * common/ProcessingStatus.vue と useUploadTracker が参照する。
 * "upload" は既存行（従来の画像アップロード）で、完了扱いにする。
 */
export interface Drawing2dProcessingStatusGroup {
	readonly ERROR: readonly string[];
	readonly PROCESSING: readonly string[];
	readonly FINISHED: readonly string[];
}

export const drawing2dProcessingStatus: Drawing2dProcessingStatusGroup = {
	ERROR: ["error"],
	PROCESSING: ["processing"],
	FINISHED: ["upload", "complete"],
};

/** GET /drawing2dImage/:siteId の 1 行（drawing_2d テーブルの列名そのまま） */
export interface Drawing2dImageListRow {
	/** drawing_2d.id（client では assetId として扱う） */
	readonly id: number;
	readonly drawing_name: string;
	readonly image_name: string;
	/** ISO8601 または "YYYY-MM-DD HH:mm" */
	readonly capture_at: string;
	/** 処理中は null */
	readonly drawing_path: string | null;
	/** 処理中は null */
	readonly drawing_json_path: string | null;
	/** 既存行は "upload" または null */
	readonly processing_status: string | null;
}

export type IsAssetUploaded = "DONE" | "PENDING" | "ERROR";

/**
 * processing_status を PointCloud モデルと同じ isAssetUploaded に写す。
 * FINISHED（null / undefined 含む）-> DONE、ERROR -> ERROR、それ以外（processing）-> PENDING。
 * 列を持たない行を扱う JS 側（Drawing2DImage.js）から undefined も渡り得る。
 */
export function deriveIsAssetUploaded(
	status: string | null | undefined,
): IsAssetUploaded {
	if (status === null || status === undefined) return "DONE";
	if (drawing2dProcessingStatus.ERROR.includes(status)) return "ERROR";
	if (drawing2dProcessingStatus.FINISHED.includes(status)) return "DONE";
	return "PENDING";
}
